module.exports = __webpack_public_path__ + "static/media/feedback_sub_date_sort_btn_white.91670a24.svg";